import { __rest, __assign } from 'tslib';
import React from 'react';
import { useMatchMedia } from '../../mq/esm';
import { isClient } from '../../shared/esm';
import { SystemMessage } from './Component.js';
import { createCompound } from './utils.js';
import 'classnames';
import './Context.js';
import './components/caption/Component.js';
import './components/controls/Component.js';
import './components/graphic/Component.js';
import './components/subtitle/Component.js';
import './components/title/Component.js';

var SystemMessageResponsiveComponent = function (_a) {
    var _b = _a.breakpoint, breakpoint = _b === void 0 ? 1024 : _b, defaultMatchMediaValue = _a.defaultMatchMediaValue, children = _a.children, restProps = __rest(_a, ["breakpoint", "defaultMatchMediaValue", "children"]);
    var query = "(min-width: ".concat(breakpoint, "px)");
    var getDefaultValue = function () { return (isClient() ? window.matchMedia(query).matches : false); };
    var isDesktop = useMatchMedia(query, defaultMatchMediaValue !== null && defaultMatchMediaValue !== void 0 ? defaultMatchMediaValue : getDefaultValue)[0];
    return (React.createElement(SystemMessage, __assign({}, restProps, { view: isDesktop ? 'desktop' : 'mobile' }), children));
};
var SystemMessageResponsive = createCompound(SystemMessageResponsiveComponent);

export { SystemMessageResponsive };
